import type { ButtonHTMLAttributes } from "react";
import { Loader2 } from "lucide-react";
import { cn } from "@/lib/cn";

type Variant = "primary" | "secondary" | "ghost" | "danger";
type Size = "sm" | "md";

const VARIANTS: Record<Variant, string> = {
    primary: "bg-brand text-white hover:brightness-110 disabled:bg-brand/50",
    secondary: "bg-surface text-ink border border-line hover:bg-surface-muted",
    ghost: "text-ink-muted hover:bg-surface-muted hover:text-ink",
    danger: "bg-danger text-white hover:brightness-110 disabled:bg-danger/50",
};

const SIZES: Record<Size, string> = {
    sm: "h-8 px-3 text-sm",
    md: "h-10 px-4 text-sm",
};

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
    variant?: Variant;
    size?: Size;
    loading?: boolean;
};

export function Button({
    variant = "primary",
    size = "md",
    loading = false,
    disabled,
    className,
    children,
    ...props
}: ButtonProps) {
    return (
        <button
            {...props}
            disabled={disabled ?? loading}
            className={cn(
                // shrink-0 + whitespace-nowrap: nút là phần tử có kích thước cố
                // định theo nội dung. Thiếu hai lớp này thì flex cha bóp nút lại
                // và chữ xuống dòng giữa chừng.
                "inline-flex shrink-0 items-center justify-center gap-2 whitespace-nowrap rounded-lg font-medium transition",
                "disabled:cursor-not-allowed disabled:opacity-70",
                VARIANTS[variant],
                SIZES[size],
                className,
            )}
        >
            {loading && <Loader2 className="size-4 animate-spin" aria-hidden />}
            {children}
        </button>
    );
}
